// extracted by css-extract-rspack-plugin
export default {"title":"BUzM5aBEGF4ylYP_","section":"cEvwTbVl8a4UF3lT","field":"DTUil3LP92kBParj","label":"cBwkiMYPKGIPMN8U","value":"Yon2Pv8QAvUdv5WD","list":"K_3uNym3G583j71I"};